<template>
  <div class="col-12">
    <!-- <button class="btn btn-dark comprelivro" @click="abreModal">Adquira o Livro agora</button> -->
    <a href="https://facebook.com/" target="_blank" :class="['btn-sm', 'mx-1', 'btn', 'btn-' + btn]">
      <i class="bi bi-facebook fs-5 text-primary"></i>
    </a>
    <a href="https://www.instagram.com/saiadosofabr" target="_blank" :class="['btn-sm', 'mx-1', 'btn', 'btn-' + btn]">
      <i class="bi bi-instagram fs-5 text-success"></i>
    </a>
    <a href="https://youtube.com" target="_blank" :class="['btn-sm', 'mx-1', 'btn', 'btn-' + btn]">
      <i class="bi bi-youtube fs-5 text-danger"></i>
    </a>

  </div>
</template>

<script>
import Modal from './Modal.vue';
import Youtube from './Youtube.vue';
export default {
  name: "Social",
  components: { Modal, Youtube },
  props: ['btn', 'facebook', 'instagram', 'youtube'],
  methods: {
    abreModal() {
      document.querySelector("#btn_modal_livro").click();
    },
    hidden() {
      this.link_youtube = false;
    }
  },
  data() {
    return {
      link_youtube: false
    }
  },
};
</script>

<style scoped>
.comprelivro {
  background-color: var(--cor-base-texto);
}
</style>